import { Link } from "react-router-dom";

const CardComponent = ({ item, index }) => {
  return (
    <div
      className="newGradient2 col-lg-12 col-md-12 mb-2 bg-white"
      key={index}
   
    >
      <div className=" rounded h-100 p-4 d-flex flex-column">
        <div className="d-flex align-items-center mb-1">
          {/* <i className={`${item.icon} fs-4 text-secondary me-2`} /> */}
          <h6 className="">{item.title}</h6>
        </div>
        <div
          className="accordion-body px-3"
          style={{ background: "#fff", borderRadius: "0.5rem" }}
        >
          {item.description}
        </div>
      </div>
    </div>
  );
};

export default CardComponent;
